import React, { useEffect, useState } from 'react';
import { AutocompleteField } from '@eb/eds-autocomplete-field';
import { InputField } from '@eb/eds-input-field';

const BareAutocompleteField = ({ id, placeholder, prefix }) => (
    <div
        className="eds-autocomplete-field"
        data-testid="autocomplete-field-wrapper"
    >
        <div className="eds-autocomplete-field__dropdown-holder">
            <InputField
                id={id}
                className="autocomplete-field"
                style="basic"
                label="autocomplete"
                placeholder={placeholder}
                prefix={prefix}
            />
        </div>
    </div>
);

export default function AutocompleteFieldWithFallback(props) {
    const [isInBrowser, setIsInBrowser] = useState(false);

    useEffect(() => setIsInBrowser(true), []);

    return isInBrowser ? (
        <AutocompleteField {...props} />
    ) : (
        <BareAutocompleteField {...props} />
    );
}
